
// reactstrap components
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Table,
  Container,
  Row,
  UncontrolledTooltip
} from "reactstrap";
// core components
import Header from "components/Headers/Header.js";
import { useAccount } from "flow/flowContext";
import { useEffect, useState } from "react";
import { getAccountData } from "flow/scripts/account";
import StorageManagerHeader from "components/Headers/StorageManagerHeader";
import { iterateOnStoragePaths } from "flow/scripts/account";
import { iterateOnPublicPaths } from "flow/scripts/account";
import { iterateOnPrivatePaths } from "flow/scripts/account";

import { JsonView, darkStyles, defaultStyles } from 'react-json-view-lite';

const StorageManager = () => {

  const { address, isConnected, disconnect, connect } = useAccount();
  const [accountData, setAccountData] = useState(null);

  const [storagePaths, setStoragePaths] = useState(null);
  const [publicStoragePaths, setPublicStoragePaths] = useState(null);
  const [privateStoragePaths, setPrivateStoragePaths] = useState(null);


  const fetchAccountData = async () =>{
    const accountData = await getAccountData(address)
    const storageData = await iterateOnStoragePaths(address)
    const publicStorageData = await iterateOnPublicPaths(address)
    const privateStorageData = await iterateOnPrivatePaths(address)
    setPrivateStoragePaths(privateStorageData)
    setPublicStoragePaths(publicStorageData)
    setStoragePaths(storageData)
    setAccountData(accountData)
  }

  useEffect(() => {
    fetchAccountData()
  }, [])



  return (
    <>
      <StorageManagerHeader accountData={accountData} paths={{storagePaths, publicStoragePaths, privateStoragePaths}}/>
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col"> 
            <Card className="shadow" >
              <CardHeader className="border-0">
                <h3 className="mb-0">Storage</h3>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Path</th>
                    <th scope="col">Items</th>
                    <th scope="col">Kind</th>
                    <th scope="col">TypeId</th>
                  </tr>
                </thead>
                <tbody>
                {storagePaths && storagePaths.map((pathItem) =>{
                      return(
                      <>
                        <tr>
                          <th scope="row">
                            <Media className="align-items-center">
                            
                              <Media>
                                <span className="mb-0 text-sm">
                                {pathItem?.path}
                                </span>
                              </Media>
                            </Media>
                          </th>
                          <td>{pathItem?.pathObject?.identifier}</td>
                          <td>
                              {pathItem?.type?.kind}
                          </td>

                          <td>
                              
                              <JsonView data={pathItem?.type} shouldInitiallyExpand={(level) => false} style={darkStyles} />

                          </td>
                        
                   
                        </tr>
                      </>)
                })}

                  
                  
                </tbody>
              </Table>
            </Card>
          </div>
        </Row>
        {/* Dark table */}
        <Row className="mt-5">
          <div className="col">
            <Card className="bg-default shadow">
              <CardHeader className="bg-transparent border-0">
                <h3 className="text-white mb-0">Public Storage</h3>
              </CardHeader>
              <Table
                className="align-items-center table-dark table-flush"
                responsive
              >
                <thead className="thead-dark">
                <tr>
                    <th scope="col">Path</th>
                    <th scope="col">Items</th>
                    <th scope="col">Kind</th>
                    <th scope="col">TypeId</th>
                  </tr>
                </thead>
                <tbody>
                {publicStoragePaths && publicStoragePaths.map((pathItem) =>{
                      return(
                      <>
                        <tr>
                          <th scope="row">
                            <Media className="align-items-center">
                            
                              <Media>
                                <span className="mb-0 text-sm">
                                {pathItem?.path}
                                </span>
                              </Media>
                            </Media>
                          </th>
                          <td>{pathItem?.pathObject?.identifier}</td>
                          <td>
                              {pathItem?.type?.kind}
                          </td>

                          <td>
                          <JsonView data={pathItem?.type} shouldInitiallyExpand={(level) => false} style={defaultStyles} />
                          </td>
                        
                   
                        </tr>
                      </>)
                })}
                  
                </tbody>
              </Table>
            </Card>
          </div>
        </Row>


        <Row>
          <div className="col mt-6"> 
            <Card className="shadow" >
              <CardHeader className="border-0">
                <h3 className="mb-0">Private Storage</h3>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Path</th>
                    <th scope="col">Items</th>
                    <th scope="col">Kind</th>
                    <th scope="col">TypeId</th>
                  </tr>
                </thead>
                <tbody>
                {privateStoragePaths && privateStoragePaths.map((pathItem) =>{
                      return(
                      <>
                        <tr>
                          <th scope="row">
                            <Media className="align-items-center">
                            
                              <Media>
                                <span className="mb-0 text-sm">
                                {pathItem?.path}
                                </span>
                              </Media>
                            </Media>
                          </th>
                          <td>{pathItem?.pathObject?.identifier}</td>
                          <td>
                              {pathItem?.type?.kind}
                          </td>

                          <td>
                          <JsonView data={pathItem?.type} shouldInitiallyExpand={(level) => false} style={defaultStyles} />
                          </td>
                        
                   
                        </tr>
                      </>)
                })}
                  
                  
                </tbody>
              </Table>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default StorageManager;
